{
  "panel": {
    "title": "Notlar",
    "newNote_title": "Yeni not",
    "search_placeholder": "Notlarda ara…",
    "search_aria": "Notlarda ara",
    "clearSearch_aria": "Aramayı temizle",
    "editorPlaceholder": "Aklınızda ne var…",
    "titleInput_placeholder": "Başlık Yok",
    "untitled": "Başlıksız",
    "emptyNote": "Boş not",
    "loadingNotes": "Notlar yükleniyor…",
    "noNotesYet": "Henüz not yok. Oluşturmak için + simgesine dokunun.",
    "noResults": "\"{{query}}\" için sonuç yok",
    "noNotesTagged": "{{tag}} etiketli not yok",
    "tagFilterAll": "Tümü",
    "filterByTag_aria": "Etikete göre filtrele",
    "templates": "Şablonlar",
    "editorTheme_aria": "Düzenleyici teması",
    "themeActive_aria": "{{theme}} teması (etkin)",
    "theme_aria": "{{theme}} teması",
    "themeName": {
      "dark": "Koyu",
      "sepia": "Sepya",
      "light": "Açık",
      "forest": "Orman"
    },
    "voice": "Ses",
    "voice_title": "Sesli not",
    "voiceUnavailable_title": "Bu tarayıcıda konuşma kullanılamıyor",
    "openVoiceRecorder_aria": "Sesli not kaydediciyi aç",
    "summarizing_title": "Özetleniyor…",
    "summarize_title": "Özetle",
    "summarizeNote_aria": "Notu özetle",
    "aiCommands_title": "AI komutları  Cmd+K",
    "openAiPalette_aria": "AI komut paletini aç",
    "enterFocusMode_title": "Odak modu  Cmd+Shift+F",
    "exitFocusMode_title": "Odak modundan çık  Cmd+Shift+F",
    "enterFocusMode_aria": "Odak moduna gir",
    "exitFocusMode_aria": "Odak modundan çık",
    "export_title": "Notu dışa aktar",
    "delete_title": "Notu sil",
    "delete_aria": "Notu sil",
    "moreActions_title": "Diğer işlemler",
    "wordCount_one": "{{formatted}} kelime · ~{{minutes}} dk okuma",
    "wordCount_other": "{{formatted}} kelime · ~{{minutes}} dk okuma",
    "referencedBy_one": "{{count}} not tarafından referans verildi",
    "referencedBy_other": "{{count}} not tarafından referans verildi",
    "noMatchingNotes": "Eşleşen not yok",
    "mobileTabs_aria": "Notlar görünümü",
    "mobileTabNotes": "Notlar",
    "mobileTabEditor": "Düzenleyici",
    "saveFailed": "Not kaydedilemedi: {{message}}",
    "deleteFailed": "Not silinemedi",
    "loadFailed": "Notlar yüklenemedi",
    "analyzeFailed": "Not analiz edilemedi",
    "aiCommandFailed": "AI komutu başarısız oldu",
    "unknownError": "Bilinmeyen hata"
  },
  "paywall": {
    "title": "Notlar, Rhemn Pro'nun bir parçasıdır",
    "safariBody": "Rhemn Pro ile senkronize notların, dikte ve yapay zeka özetlerinin kilidini açın. Zaten üye misiniz? Giriş yaptığınızda otomatik olarak açılır.",
    "body": "Senkronize notların, tarayıcı tabanlı dikte ve yapılandırılmış AI özetlerinin kilidini açın."
  },
  "format": {
    "bold": "Kalın",
    "italic": "İtalik",
    "strikethrough": "Üstü çizili",
    "inlineCode": "Satır içi kod",
    "heading1": "Başlık 1",
    "heading2": "Başlık 2",
    "heading3": "Başlık 3",
    "bulletList": "Madde işaretli liste",
    "numberedList": "Numaralı liste",
    "blockquote": "Alıntı",
    "codeBlock": "Kod bloğu",
    "toggleBold_aria": "Kalını aç/kapat",
    "toggleItalic_aria": "İtaliği aç/kapat",
    "toggleStrikethrough_aria": "Üstü çiziliyi aç/kapat",
    "toggleInlineCode_aria": "Satır içi kodu aç/kapat",
    "toggleBulletList_aria": "Madde işaretli listeyi aç/kapat",
    "toggleNumberedList_aria": "Numaralı listeyi aç/kapat",
    "toggleBlockquote_aria": "Alıntıyı aç/kapat",
    "formatOptions_aria": "Biçimlendirme seçenekleri"
  },
  "analysis": {
    "heading": "Özet",
    "onDevice": "⚡ Cihazda",
    "onDevice_aria": "Cihazda işlendi",
    "applyToNote_title": "Nota uygula",
    "applyToNote_aria": "Özeti nota uygula",
    "summaryLabel": "Özet",
    "keyPointsLabel": "Önemli Noktalar",
    "noKeyPoints": "Bu not için önemli nokta döndürülmedi."
  },
  "export": {
    "markdown": "Markdown olarak dışa aktar",
    "plainText": "Düz metin olarak dışa aktar",
    "pdf": "PDF olarak dışa aktar",
    "allZip": "Tümünü ZIP olarak dışa aktar",
    "label": "Dışa aktar"
  },
  "cmdk": {
    "dialog_aria": "AI komut paleti",
    "input_placeholder": "AI'ya sorun veya bir komut çalıştırın…",
    "esc": "Esc",
    "back_aria": "Geri",
    "translateTo": "Şu dile çevir",
    "language_placeholder": "Dil…",
    "aiActions": "AI İşlemleri",
    "noCommandsMatch": "\"{{query}}\" ile eşleşen komut yok",
    "continue": {
      "label": "Yazmaya devam et",
      "description": "Kaldığınız yerden devam edin"
    },
    "summarize": {
      "label": "Seçimi özetle",
      "description": "Önemli noktalara indirgeyin"
    },
    "formal": {
      "label": "Bunu resmileştir",
      "description": "Tonu profesyonelleştirin"
    },
    "simplify": {
      "label": "Sadeleştir",
      "description": "Daha kısa, daha net dil"
    },
    "translate": {
      "label": "Şu dile çevir…",
      "description": "Başka bir dile çevirin"
    },
    "expand": {
      "label": "Bu maddeyi genişlet",
      "description": "Seçili maddeyi metne dönüştürün"
    },
    "languages": {
      "Spanish": "İspanyolca",
      "Arabic": "Arapça",
      "French": "Fransızca",
      "German": "Almanca",
      "Japanese": "Japonca",
      "Portuguese": "Portekizce"
    }
  },
  "templates": {
    "dialog_aria": "Şablon seç",
    "header": "Bir Şablon Seçin",
    "builtInLabel": "Yerleşik",
    "myTemplatesLabel": "Şablonlarım",
    "saveCurrent": "Mevcut notu şablon olarak kaydet",
    "myTemplatesEmpty": "Kaydettiğiniz şablonlar burada görünecek",
    "useTemplate": "Şablonu Kullan",
    "meeting": {
      "name": "Toplantı Notları",
      "description": "Kararları ve eylem maddelerini kaydedin",
      "structure": "Katılımcılar / Gündem / Notlar / Eylemler"
    },
    "journal": {
      "name": "Günlük",
      "description": "Gününüz üzerine düşünün",
      "structure": "Şükran / Bugünün kazanımları / Notlar"
    },
    "book": {
      "name": "Kitap Özeti",
      "description": "Bir kitaptan önemli fikirleri kaydedin",
      "structure": "Ana fikir / Önemli alıntılar / Çıkarımlar"
    },
    "project": {
      "name": "Proje Özeti",
      "description": "Kapsamı, hedefleri ve paydaşları belirleyin",
      "structure": "Hedef / Kapsam / Riskler / Zaman çizelgesi"
    },
    "brainstorm": {
      "name": "Beyin Fırtınası",
      "description": "Serbest biçimli fikir toplama",
      "structure": "Konu / Fikirler / Sonraki adımlar"
    },
    "weekly": {
      "name": "Haftalık Değerlendirme",
      "description": "Haftanızı gözden geçirin ve planlayın",
      "structure": "Kazanımlar / Zorluklar / Odak alanları"
    }
  },
  "voice": {
    "dialog_aria": "Sesli not kaydedici",
    "cancel_aria": "İptal",
    "statusRecording": "Kaydediliyor",
    "statusTranscribing": "Yazıya dökülüyor…",
    "statusReview": "Gözden geçir",
    "skip": "Atla",
    "mark": "İşaretle",
    "mark_title": "Zaman damgası işareti bırak",
    "captureMeeting": "Toplantıyı yakala",
    "captureMeeting_title": "Bir toplantı sekmesinden de ses yakala",
    "meeting": "Toplantı",
    "meeting_title": "Toplantı sekmesi yakalanıyor",
    "markers_aria": "Zaman damgası işaretleri",
    "listening": "Dinleniyor…",
    "micDenied": "Mikrofon erişimi kapalı. Ayarlar'dan izin verin ve tekrar deneyin.",
    "captureFailed": "Kayıt başlatılamadı. Birazdan tekrar deneyin.",
    "tabPicker_aria": "Yakalanacak bir toplantı sekmesi seçin",
    "captureFrom": "Şuradan ses yakala…",
    "noAudibleTab": "Hiçbir sekme ses çalmıyor. Toplantınızı açın ve birinin konuştuğundan emin olun, ardından tekrar deneyin.",
    "tabPickerCancel": "İptal",
    "tabTranscript": "Metin dökümü",
    "structuring": "Yapılandırılıyor…",
    "structuredNote": "Yapılandırılmış Not",
    "structureFailed": "Yapılandırılmış not oluşturulamadı.",
    "retryStructure": "Tekrar dene",
    "browserTranscript": "Tarayıcı metin dökümü",
    "nothingCaptured": "Hiçbir şey yakalanmadı.",
    "buildingStructured": "Yapılandırılmış not oluşturuluyor…",
    "cancel": "İptal",
    "stop": "Durdur",
    "recordAgain": "Tekrar kaydet",
    "saveToNote": "Nota Kaydet",
    "statusMeeting": "Toplantı",
    "captureStrip_aria": "{{tab}} sekmesinden ses yakalanıyor",
    "stopCapture": "Yakalamayı durdur",
    "stopCapture_title": "Sekme yakalamayı durdur — mikrofon kaydetmeye devam eder",
    "stopsIn": "{{time}} içinde duracak",
    "autoStopped": "Kayıt 60 dakikalık sınırda durduruldu.",
    "autoStoppedQuota": "Kayıt durduruldu — bu ayın transkripsiyon dakikalarını kullandınız.",
    "captureLost": "Toplantı sekmesi kapandı. Mikrofonunuz hâlâ kaydediyor.",
    "tabSummary": "Özet",
    "noSpeakers": "Konuşmacılar belirlenemedi",
    "speakerN": "Konuşmacı {{number}}",
    "renameSpeaker_aria": "{{name}} adını değiştir — tüm satırlarına uygulanır",
    "renameSpeaker_input_aria": "Konuşmacı adı",
    "turnTime_title": "{{time}} anında söylendi",
    "actionItemsTitle": "Yapılacaklar",
    "actionsCount": "{{checked}} / {{total}}",
    "addToTasks_one": "{{count}} öğeyi Görevlere ekle",
    "addToTasks_other": "{{count}} öğeyi Görevlere ekle",
    "addToTasksZero": "Görevlere ekle",
    "adding": "Ekleniyor…",
    "tasksAdded_one": "{{count}} görev eklendi",
    "tasksAdded_other": "{{count}} görev eklendi",
    "viewTasks": "Görüntüle",
    "addFailed": "Eklenemedi — tekrar deneyin.",
    "minutesLeft_one": "{{count}} dk kaldı",
    "minutesLeft_other": "{{count}} dk kaldı",
    "minutesLeftShort_one": "{{count}} dk kaldı",
    "minutesLeftShort_other": "{{count}} dk kaldı",
    "minutesLeft_title": "Bu ay {{count}} transkripsiyon dakikası kaldı",
    "quotaExhausted": "Bu ayın toplantı dakikalarını kullandınız. {{date}} tarihinde yenilenir.",
    "quotaUnknown": "Kalan dakika bilinmiyor — kayıt aylık sınırına takılabilir",
    "meetingProRequired": "Toplantı transkripsiyonu Pro'nun bir parçasıdır. Canlı transkriptiniz aşağıda korunuyor.",
    "gateTitle": "Toplantı kaydı",
    "gateBody": "Mikrofonunuzla birlikte bir toplantı sekmesini kaydedin — konuşmacılar belirlenir, yapılacaklar çıkarılır. Pro'ya dahildir.",
    "gateLater": "Şimdi değil",
    "gateCta": "Pro'yu gör",
    "roomOption": "Sekme yok — odayı kaydet",
    "roomHint": "Hoparlörde bir arama, ayrı bir uygulama veya odadaki insanlar — sesli duyabildiğiniz her şey.",
    "roomHint_title": "Karşı taraf kulaklığınızdaysa mikrofon onları duyamaz — hoparlörü kullanın.",
    "recordRoom": "Odayı kaydet",
    "recordRoom_title": "Mikrofonun duyduğu herkesi kaydet — konuşmacılar belirlenir",
    "roomStart": "Başlat",
    "statusRoom": "Oda",
    "roomStrip": "Oda kaydediliyor",
    "roomStrip_aria": "Oda kaydediliyor — mikrofonun duyduğu herkes",
    "roomOff": "Kapat",
    "roomOff_title": "Oda modunu kapat — bu, sıradan bir sesli nota dönüşür",
    "roomRenameHint": "Yeniden adlandırmak için bir ada dokunun — bunlardan biri sizsiniz.",
    "gateBodyRoom": "Çevrenizde söylenenleri kaydedin — konuşmacılar belirlenir, yapılacaklar çıkarılır. Pro'ya dahildir.",
    "roomHintDevice": "Bu cihazdaki aramalar kaydedilemez — iOS onları gizli tutar. Hoparlördeki başka bir telefon veya odadaki bir konuşma ise kaydedilebilir.",
    "autoStoppedSize": "Kayıt, yükleme boyutu sınırında durduruldu.",
    "tooLarge": "Kayıt yüklenemeyecek kadar büyüktü, bu yüzden transkripsiyonu yapılamadı.",
    "destTo": "Liste",
    "dest_aria": "Listeye ekle: {{name}}",
    "destMenu_aria": "Bir liste seç",
    "destNewPending_aria": "Yeni liste: {{name}}"
  },
  "meetingNotice": {
    "title": "Toplantılar, notlarınızda",
    "body": "Rhemn artık seçtiğiniz bir toplantı sekmesini kaydedebilir — yalnızca sesli not kaydederken ve yalnızca seçtiğiniz sekmeyi.",
    "factPrivacy": "Ses, transkriptinizi oluşturmak için işlenir ve sonra silinir. Kayıtlar asla saklanmaz.",
    "factControl": "Kayda basıp bir sekme seçene kadar hiçbir şey yakalanmaz.",
    "cta": "Anladım",
    "privacyLink": "Gizlilik politikamızı okuyun",
    "dialog_aria": "Yeni toplantı kaydı izni hakkında"
  }
}
